<div
  class="flex-column file-upload"
  matTooltip="Select a file or drag and drop a file here."
>
  <div
    class="drag-area"
    (drop)="drop($event)"
    (dragover)="drag($event)"
    (click)="dataFile.click()"
    (keyup.enter)="dataFile.click()"
    tabindex="0"
  >
    <div
      class="content-wrapper"
      [class.no-file-selected]="!validFile"
      [class.file-selected]="validFile"
    >
      <span class="label">Amendment File</span>
      @if (!validFile) {
        <span class="icon-wrapper"><mat-icon>upload_file</mat-icon></span>
        <span class="label"
          >No file selected.<br />Select a file or drag and drop a file
          here.</span
        >
      }
      @if (validFile) {
        <span class="icon-wrapper"><mat-icon>done</mat-icon></span>
        <div class="file-info">
          <span class="file-info-label">File Name:</span>
          <span class="file-info-value facts">{{ validFile.name }}</span>
          <span class="file-info-label">File Size:</span>
          <span class="file-info-value facts"
            >{{ byteConverter(validFile.size) }} KB</span
          >
        </div>
      }
    </div>
    <input
      #dataFile
      type="file"
      id="amendmentFile"
      hidden
      (change)="selectAmendmentFile($event.target.files[0])"
      accept=".pdf"
      [disabled]="disabled"
    />
  </div>
</div>
